import React, { useCallback, useEffect, useRef, useState } from "react"
import Select from 'react-select';
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import Input from "../../components/utils/Input";
import { addArticleWorkingShift, setDetailArticle, updateArticleWorkingShift } from "../../action/cassa";
import { roleId } from "../../constants/app";
import { parseNumToFixed } from "../../utils/common";
import { fetchArticlesCashCategories } from "../../action/handbook";

const optionsTypeTransaction = [
    {label: 'Наличные', value: 'cash'},
    {label: 'Безнал.', value: 'noncash'}
];

const WorkingShiftAddArticles = () => {
    const ref = useRef();
    const dispatch = useDispatch();
    const articlesCash = useSelector(state => state.handbook.articlesCash);
    const articlesCashCategories = useSelector(state => state.handbook.articlesCashCategories);
    const loadingCategories = useSelector(state => state.loaders.articlesCashCategories);
    const typeMovementCash = useSelector(state => state.cassa.typeMovementCash);
    const detailArticle = useSelector(state => state.cassa.detailArticle);
    const user = useSelector(state => state.user.info);
    const touchStartedRef = useRef(false);

    const [article, setArticle] = useState({
        created_at: null,
        name: null,
        sum: null,
        typeTransaction: null,
        author: null,
        comment: null,
    });
    const [availableArticles, setAvailableArticles] = useState(null);
    const [category, setCategory] = useState(null);

    useEffect(() => {
        if(typeMovementCash === 'incasso') {
            const data = {...article};
            data.typeTransaction = 'cash';
            setArticle(data);
        }

        if(detailArticle) setArticle(detailArticle);
        dispatch(fetchArticlesCashCategories(true));
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        const userRole = user.role.id;
        let filteredArticles = articlesCash;
        if(userRole === roleId.manager || userRole === roleId.cashier) {
            filteredArticles = articlesCash.filter((item) => item.typeTransaction === 'cash' || item.typeTransaction === 'all');
            setDataArticle('typeTransaction')({value: 'cash'});
        }

        setAvailableArticles(filteredArticles.map(item => ({ label: item.name, value: item.id })));
        // eslint-disable-next-line
    }, [user]);

    useEffect(() => {
        let filteredArticles = articlesCash;
        const userRole = user.role.id;

        if(userRole === roleId.manager || userRole === roleId.cashier) {
            setDataArticle('typeTransaction')({value: 'cash'});
        }
        
        if (category && category.value) filteredArticles = filteredArticles.filter((item) => {
            if (!item) return false;
            const categoryId = item.category ? item.category.id ? item.category.id : item.category : null;
            if (!categoryId) return false;
            if (categoryId === category.value) return true;
            return false;
        })

        if(article.typeTransaction) {
            filteredArticles = filteredArticles.filter(item => item.typeMovementCash === typeMovementCash && (item.typeTransaction === article.typeTransaction || item.typeTransaction === 'all'));
        } else {
            filteredArticles = filteredArticles.filter(item => item.typeMovementCash === typeMovementCash);
        }
        setAvailableArticles(filteredArticles.map(item => ({ label: item.name, value: item.id })));        
        // eslint-disable-next-line
    }, [article.typeTransaction, category]);

    const onClose = useCallback(() => {
        dispatch(setDetailArticle(null));
        dispatch(setActiveModalAction({ field: 'workingShiftAddArticles', value: null }));
    }, [dispatch]);
    
    useEffect(() => {
        const handleTouch = () => {
        touchStartedRef.current = true;
            setTimeout(() => {
                touchStartedRef.current = false;
            }, 500);
        };
    
        document.addEventListener('touchcancel', handleTouch);
        document.addEventListener('touchstart', handleTouch);
        document.addEventListener('touchend', handleTouch);
    
        return () => {
            document.removeEventListener('touchcancel', handleTouch);
            document.removeEventListener('touchstart', handleTouch);
            document.removeEventListener('touchend', handleTouch);
        };
    }, []);
    
    useEffect(() => {
        const handleMouseDown = (event) => {
            if (touchStartedRef.current) return;
            if (ref.current && !ref.current.contains(event.target)) {
                if (event.target.closest('.rs__menu') || event.target.closest('.rs__menu-portal')) return;
                onClose();
            }
        };
    
        document.addEventListener('mousedown', handleMouseDown);
        return () => document.removeEventListener('mousedown', handleMouseDown);
    }, [onClose]);

    const onSubmit = () => {
        const data = {...article};
        if(!detailArticle) {
            data.typeMovementCash = typeMovementCash;
            dispatch(addArticleWorkingShift(data));
        } else {
            dispatch(updateArticleWorkingShift(data))
        }

        onClose();
    }

    const isValidArticle = () => {
        if(!parseFloat(article.sum) || !article.name || !article.typeTransaction) return false;
        return true;
    }

    const setDataArticle = (field) => (e) => {
        const data = {...article};

        if (field === 'name') {
            data[field] = e.label;
            data.articleId = e.value;
        } else if (field === 'typeTransaction' || field === 'sum') {
            data[field] = e.value;
        } else {
            data[field] = e.target.value;
        }

        setArticle(data);
    }

    const renderTitle = () => {
        if(detailArticle) {
            if(typeMovementCash === 'income') return 'Изменение статьи внесения';
            if(typeMovementCash === 'incasso') return 'Изменение статьи инкассации';
            return 'Изменение статьи изъятия'; 
        } else {
            if(typeMovementCash === 'income') return 'Внесение в кассу';  
            if(typeMovementCash === 'incasso') return 'Инкассация из кассы';
            return 'Изъятие из кассы'; 
        }
    }

    return(
        <form>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div ref={ref} className="modal-content" style={{ maxHeight: '600px', height: '600px' }}>
                        <div className="modal-header">
                            <h5 className="modal-title"> {renderTitle()} </h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Тип *</div>
                                <Select
                                    classNamePrefix="rs"
                                    isDisabled={
                                        typeMovementCash === 'incasso' 
                                        || (user.role.id === roleId.manager || user.role.id === roleId.cashier)
                                        || detailArticle
                                    }
                                    placeholder='Тип'
                                    value={optionsTypeTransaction.find((el) => el.value === article.typeTransaction)}
                                    onChange={setDataArticle('typeTransaction')}
                                    options={optionsTypeTransaction}
                                    noOptionsMessage={() => 'Нет типов'}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Категория статьи</div>                               
                                <Select
                                    classNamePrefix="rs"
                                    isLoading={loadingCategories}
                                    placeholder='Категория'
                                    value={category}
                                    onChange={setCategory}
                                    options={articlesCashCategories.map((item) => ({ value: item.id, label: item.name }))}
                                    noOptionsMessage={() => 'Нет категорий'}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                <div style={{ marginBottom: '0.5rem' }}>Статья *</div>                               
                                <Select
                                    classNamePrefix="rs"
                                    isDisabled={!article.typeTransaction}
                                    placeholder='Статья'
                                    value={article.name ? {value: article.id, label: article.name} : ''}
                                    onChange={setDataArticle('name')}
                                    options={availableArticles}
                                    noOptionsMessage={() => 'Нет статей'}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                            <Input
                            disabled={detailArticle}
                            label='Сумма'
                            type="number"                            
                            required={true}
                            isControlledInput={true}
                            onChange={(e) => {
                                const value = parseNumToFixed(e.target.value);
                                if (value >= 0) {
                                    setDataArticle('sum')({value});
                                } else {
                                    setDataArticle('sum')({value: 0});
                                }
                            }}
                            value={article.sum}
                            placeholder='Сумма'
                            />
                            <Input
                            disabled={detailArticle}
                            label='Примечание'
                            textarea={true}                            
                            onChange={setDataArticle('comment')}
                            value={article.comment}
                            placeholder='Примечание'
                            />
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Закрыть</button>
                            <button disabled={!isValidArticle()} type="button" onClick={onSubmit} className='btn btn-primary'>Сохранить</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default withRouter(WorkingShiftAddArticles);